import { useState, useEffect } from 'react';
import { getDadosPessoaisUsuario } from '../../../api/autenticacao';
import { useMenuSidebar } from '../../../contexts/MenuSidebarContext';
import { getDadosUsuario, setDadosUsuario } from '../../../services/authentication/auth';

export default function useUserSidebarHook() {
  const { user, setUser } = useMenuSidebar();
  const [msgErro, setMsgErro] = useState('');
  const [alert, setAlert] = useState(false);

  async function buscarUsuarioLogado() {
    await getDadosPessoaisUsuario()
      .then(response => {
        const { NOME, EMAIL, APELIDO, TIPO, NIVEL, UUID } = response.data;
        const nomeFormatado = formatarNome(NOME);
        const apelidoFormatado = formatarNome(APELIDO);
        const dadosSession = getDadosUsuario();
        const dadosUsuario = {
          nome: nomeFormatado,
          email: EMAIL,
          apelido: apelidoFormatado,
          codTipoPerfil: TIPO,
          nivel: NIVEL,
          uuid: UUID,
          ...dadosSession
        };
        setDadosUsuario(dadosUsuario);
        setUser(dadosUsuario);
      })
      .catch(err => {
        setAlert(true);
        setMsgErro('falha ao buscar usuário', err);
      });
  }

  const formatarNome = nome =>
    nome
      .toLowerCase()
      .split(' ')
      .map(palavra => palavra.charAt(0).toUpperCase() + palavra.slice(1))
      .join(' ');

  useEffect(() => {
    const dadosUsuario = getDadosUsuario();
    if (dadosUsuario) {
      setUser(dadosUsuario);
    } else {
      buscarUsuarioLogado();
    }
  }, []);

  return {
    user,
    msgErro,
    alert,
    setAlert
  };
}
